export const fallbackLanguage = 'lv' as const

const supportedLanguages = ['lv', 'en'] as const

export type Language = (typeof supportedLanguages)[number]

const languageStorageKey = 'edy365_lang'

export const normalizeLanguage = (value: unknown): Language | undefined =>
  typeof value === 'string' && supportedLanguages.includes(value as Language)
    ? (value as Language)
    : undefined

const readStoredLanguage = () => {
  if (typeof window === 'undefined') {
    return undefined
  }

  try {
    return normalizeLanguage(window.localStorage.getItem(languageStorageKey))
  } catch {
    return undefined
  }
}

export const getInitialLanguage = () => readStoredLanguage() ?? fallbackLanguage

export const setDocumentLanguage = (language: Language) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language
  }
}

export const persistLanguage = (language: Language) => {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(languageStorageKey, language)
    }
  } catch {}

  setDocumentLanguage(language)
}
